import { DialogProgrammatic as Dialog } from "buefy";

export default {
  methods: {
    checkExtension(
      file,
      valid = ["pdf", "jpeg", "png", "gif", "pdf", "doc", "docx", "txt", "text", "xls", "xlsx", "svg+xml"],
      showCustomModal = false,
    ) {
      let extension = file.type.substring(file.type.lastIndexOf("/") + 1);
      if (valid.includes(extension)) {
        return true;
      }
      let validList = "";
      for (let type of valid) {
        validList += `<li>${type !== "svg+xml" ? type : "svg"}</li>`;
      }

      if (showCustomModal) {
        Dialog.alert({
          title: "Non accepted file type",
          message: `You are trying to upload a file of a non-accepted type. Only the following file types are allowed:
          <br/><br/>
          <div class="content"> 
            <ul>
              <li>Document (doc, docx, odt, txt)</li>
              <li>PDF</li>
              <li>Presentation (pptx, pps, ppt)</li>
              <li>Image (jpg, jpeg, png, svg, bmp, tiff, tga, dpe)</li>
              <li>Spreadsheet (xls, xlsx, xlsm)</li>
              <li>Video (avi, mp4, mov, wmv, flv, mkv, webm)</li>
              <li>Audio (mp3, wav, wma)</li>
            </ul>
          </div>
          `,
          type: "is-danger",
          hasIcon: true,
          confirmText: "Ok",
          onConfirm: () => {
            return false;
          },
        });
      } else {
        Dialog.alert({
          title: "Non accepted file type",
          message: `You are trying to upload a file of a non-accepted type. Only the following file types are allowed: <div class="content"><ul>${validList}</ul></div>`,
          type: "is-danger",
          hasIcon: true,
          confirmText: "Ok",
          onConfirm: () => {
            return false;
          },
        });
      }
    },
  },
};
